import { render, staticRenderFns } from "./EntraConsentURl.vue?vue&type=template&id=18b85c81&scoped=true&"
import script from "./EntraConsentURl.vue?vue&type=script&lang=js&"
export * from "./EntraConsentURl.vue?vue&type=script&lang=js&"
import style0 from "./EntraConsentURl.vue?vue&type=style&index=0&id=18b85c81&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b85c81",
  null
  
)

export default component.exports